import { BASE_URL } from "@/utils/api/Urls";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export default fetchBaseQuery({
  baseUrl: BASE_URL,
});
